"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
/**
 * Params Are sent in object containing the following:
 * @param {string}  baseColor - A string param (the color to generate tints and shades of).
 * @param {number[]} darkSet - An optional param (Array of the values to have tints for, default Values [0.24, 0.48, 0.64, 0.72])
 * @param {number[]} brightSet - An optional param (Array of the values to have shades for, default Values [0.16, 0.4, 0.64, 0.8, 0.92]).
 * @returns {string[]} Array of string colors values
 */
var generateColors = function (_a) {
    var baseColor = _a.baseColor, darkSet = _a.darkSet, brightSet = _a.brightSet;
    var color = (0, polished_1.parseToRgb)(baseColor);
    var red = color.red, green = color.green, blue = color.blue;
    var darkArray = darkSet || [0.24, 0.48, 0.64, 0.72];
    var brightArray = brightSet || [0.16, 0.4, 0.64, 0.8, 0.92];
    var colors = [];
    brightArray.forEach(function (brightValue) {
        var tintedRed = Math.round(red + (255 - red) * brightValue);
        var tintedGreen = Math.round(green + (255 - green) * brightValue);
        var tintedBlue = Math.round(blue + (255 - blue) * brightValue);
        var result = (0, polished_1.rgbToColorString)({
            red: tintedRed,
            green: tintedGreen,
            blue: tintedBlue,
        });
        colors.push(result);
    });
    colors.reverse().push(baseColor);
    darkArray.forEach(function (darkValue) {
        var shadedRed = Math.round(red * (1 - darkValue));
        var shadedGreen = Math.round(green * (1 - darkValue));
        var shadedBlue = Math.round(blue * (1 - darkValue));
        var result = (0, polished_1.rgbToColorString)({
            red: shadedRed,
            green: shadedGreen,
            blue: shadedBlue,
        });
        colors.push(result);
    });
    return colors;
};
exports.default = generateColors;
